import toast from 'react-hot-toast';

export function Toast(type: string, text: string){
  switch (type) {
    case "error":
      return (toast.error(text, {style: {
        border: '1px solid #d80a0a',
        padding: '16px',
        color: '#d80a0a',
      }, iconTheme:{
        primary: '#d80a0a',
        secondary: '#FFFAEE',
      }}))
    default:
      return (toast.success(text, {style: {
        border: '1px solid #3e9278',
        padding: '16px',
        color: '#179970',
      }, iconTheme:{
        primary: '#3e9278',
        secondary: '#FFFAEE',
      }}))
  }}